import "./ContactInfo.css";
import { FaPhoneAlt } from "react-icons/fa";

export default function ContactInfo() {
  return (
    <section className="contact-section" id="contact">

      {/* HEADER */}
      <div className="contact-header">
        <span>REACH US</span>
        <h2>
          Need Help? <span>Contact Us</span>
        </h2>
      </div>

      {/* MAP */}
      <div className="map-box">
        <iframe
          src="https://www.google.com/maps?q=Bangalore&output=embed"
          title="map"
        ></iframe>
      </div>

      <div className="contact-list">

        <div className="contact-item">
          <div className="icon">📍</div>
          <div className="content">
            <h4>Address</h4>
            <p>No.1 Subbarama Chetty Road, Bangalore - 560004</p>
          </div>
        </div>

        <div className="contact-item">
          <div className="icon">✉️</div>
          <div className="content">
            <h4>Email</h4>
            <p>info@goldcompany.com</p>
          </div>
        </div>

        <div className="contact-item">
          <div className="icon">
            <FaPhoneAlt />
          </div>

          <div className="content">
            <h4>Phone</h4>
            <p>+918884448033</p>
          </div>
        </div>

        <div className="contact-item">
          <div className="icon">⏰</div>
          <div className="content">
            <h4>Working Hours</h4>
            <p>Mon–Sat: 9:30 AM – 5:30 PM</p>
          </div>
        </div>

      </div>

    </section>
  );
}